<template>
  <form
    id="shippingDestinyTransportationForm"
    class="mx-auto col-sm-8"
    @submit.prevent
  >
    <div class="form-group" :class="{ 'has-error': errors.has('shipping_destiny_transportation') }">
      <label for="shipping_destiny_transportation">{{ $t("shipping_destiny_transportation") }}</label>
      <input
        type="text"
        id="shipping_destiny_transportation"
        name="shipping_destiny_transportation"
        class="form-control"
        :placeholder="$t('ph_shipping_destiny_transportation')"
        v-model="shippingDestinyTransportation.name"
        v-validate="'required'"
        @input="shippingDestinyTransportation.name = shippingDestinyTransportation.name.toUpperCase()"
      />

      <small v-show="errors.has('shipping_destiny_transportation')" class="form-text">
        {{ errors.first("shipping_destiny_transportation") }}
      </small>
    </div>

    <div class="switch mb-3">
      <label for="isActive">{{ $t("active") }}</label>
      <div class="onoffswitch2">
        <input
          type="checkbox"
          class="onoffswitch2-checkbox"
          id="isActive"
          v-model="shippingDestinyTransportation.isActive"
        />
        <label class="onoffswitch2-label" for="isActive">
          <span class="onoffswitch2-inner"></span>
          <span class="onoffswitch2-switch"></span>
        </label>
      </div>
    </div>

    <div class="form-group row">
      <div class="col-sm-4 col-sm-offset-2">
        <LoaderButton @click="onClick">
          {{ $t("save") }}
        </LoaderButton>
      </div>
    </div>
  </form>
</template>

<script>
import { mapActions } from "vuex";
import LoaderButton from "@/components/button/LoaderButton";

export default {
  name: "ShippingDestinyTransportationForm",

  components: {
    LoaderButton,
  },

  props: {
    shippingDestinyTransportation: {
      type: Object,
      default: () => ({
        name: "",
        isActive: true,
      }),
    },
  },

  methods: {
    ...mapActions("shippingdestinytransportation", ["create", "edit", "cleanState"]),

    async onClick(evtClick, doneFn) {
      const isValid = await this.$validator.validateAll();

      if (!isValid) {
        const err = new Error(this.$t("invalid_form_fields"));

        this.$store.dispatch("notify/error", err);

        return;
      }

      const { id } = this.shippingDestinyTransportation;

      const result = (await id)
        ? await this.edit({ id, data: this.shippingDestinyTransportation })
        : await this.create(this.shippingDestinyTransportation);

      if (result) {
        this.$router.push({ name: "listshippingdestinytransportation" });
      }
    },
  },

  destroyed() {
    this.cleanState();
  },
};
</script>
